import { usePageContext } from '../../providers/PageProvider';
import { FixtureSummary } from './components/FixtureSummary';
import { Workspace } from './components/Workspace';

export const Content = () => {
  const { isLocalFixture } = usePageContext();

  return (
    <div className="p-6 bg-[var(--color-page)] min-h-screen text-[var(--color-text)] flex flex-col gap-4">
      {isLocalFixture ? (
        <div className="border border-[var(--color-border)] rounded-[8px] bg-[var(--color-info-bg)] text-[var(--color-info-text)] px-4 py-3">
          Local fixture mode: proposals and transcript edits are stored only in this browser session.
        </div>
      ) : null}

      <FixtureSummary />
      <Workspace />
    </div>
  );
};
